import React, { useState, useEffect } from "react";
import { io } from "socket.io-client";

const baseUrl = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL;
const socket = io(baseUrl);

export default function FileShare({ isLecturer }) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    fetch(`${baseUrl}/api/files`)
      .then((res) => res.json())
      .then(setFiles)
      .catch(() => {});

    socket.on("new-file", (file) => {
      setFiles((prev) => [...prev, file]);
    });
    socket.on("file-deleted", ({ filename }) => {
      setFiles((prev) =>
        prev.filter((f) => f.url.split("/").pop() !== filename)
      );
    });
    return () => {
      socket.off("new-file");
      socket.off("file-deleted");
    };
  }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    await fetch(`${baseUrl}/upload`, {
      method: "POST",
      body: formData,
    });
    setUploading(false);
    e.target.value = "";
    // Файл появится через сокет
  };

  const handleDelete = (file) => {
    if (!window.confirm(`Удалить файл ${file.name}?`)) return;
    fetch(
      `${baseUrl}/api/files/${encodeURIComponent(file.url.split("/").pop())}`,
      {
        method: "DELETE",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setFiles((prev) => prev.filter((f) => f.url !== file.url));
        }
      });
  };

  return (
    <div
      style={{
        border: "1px solid #ccc",
        padding: 10,
        maxWidth: 400,
        margin: "10px auto",
      }}
    >
      {isLecturer && (
        <div style={{ marginBottom: 8 }}>
          <input type="file" onChange={handleUpload} disabled={uploading} />
          {uploading && <span>Загрузка...</span>}
        </div>
      )}
      <div>
        <b>Файлы для скачивания:</b>
        <ul>
          {files.map((file, idx) => (
            <li key={idx} style={{ display: "flex", alignItems: "center" }}>
              <a href={`${baseUrl}${file.url}`} download>
                {file.name}
              </a>
              {isLecturer && (
                <button
                  style={{ marginLeft: 8 }}
                  onClick={() => handleDelete(file)}
                >
                  Удалить
                </button>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
